import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { displayNameFor, organisationLabelFor } from '../userIdentity';

const actionBtnSx = {
  textTransform: 'none',
  fontFamily: 'Rubik',
  fontWeight: 600,
  fontSize: { xs: '11px', sm: '12px', xl: '15px' },
  height: { xs: '30px', sm: '32px', xl: '40px' },
  minWidth: { xs: '76px', sm: '90px', xl: '120px' },
  borderRadius: '5px',
  boxShadow: 'none',
};

/**
 * The one action on this page with a blast radius beyond the person named in the
 * row: granting through a closed organisation gate opens the product for the
 * whole company, so it is confirmed once, by name.
 */
const EnableOrgProductDialog = ({ open, request, isSubmitting, onClose, onConfirm }) => {
  const label = request?.product?.label;
  // Both fall back rather than rendering raw, so the dialog cannot open with
  // "null gets access straight away" (PA-05) or name an undefined company.
  const organisation = organisationLabelFor(request?.user);
  const name = displayNameFor(request?.user);

  return (
    <Dialog
      open={open}
      onClose={isSubmitting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: '5px' } }}
    >
      <DialogContent sx={{ p: 3 }}>
        <Typography sx={{ fontFamily: 'Rubik', fontWeight: 600, fontSize: '16px', color: '#08231B', mb: 1 }}>
          {`Turn on ${label} for ${organisation}?`}
        </Typography>
        <Typography sx={{ fontFamily: 'Rubik', fontSize: '13px', color: '#5A6474' }}>
          {`${name} gets access straight away. ${organisation}'s own admins will also be able to give ${label} to anyone else in their company.`}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={isSubmitting}
          sx={{
            ...actionBtnSx,
            borderColor: '#08231B',
            color: '#08231B',
            '&:hover': { borderColor: '#08231B', backgroundColor: '#08231B14' },
          }}
        >
          Cancel
        </Button>
        <LoadingButton
          loading={isSubmitting}
          variant="contained"
          onClick={onConfirm}
          sx={{
            ...actionBtnSx,
            backgroundColor: '#08231B',
            color: '#00d744',
            '&:hover': { backgroundColor: '#08231Bcc' },
            '&.MuiLoadingButton-loading': { color: 'transparent' },
          }}
        >
          {`Turn on ${label}`}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default EnableOrgProductDialog;
